// eslint-disable-next-line no-restricted-syntax
export enum NavigationDirection {
  Forward = 'FORWARD',
  Backwards = 'BACKWARDS',
}

// eslint-disable-next-line no-restricted-syntax
export enum ProgramTypes {
  GwG = 'GWG',
  AcademicDisciplines = 'ACADEMIC_DISCIPLINES',
  ChooseCourse = 'CHOOSE_COURSE',
}

// eslint-disable-next-line no-restricted-syntax
export enum GoogleOnboardingSteps {
  ProgramTypeSelection,
  ProgramContentCurationSelection,
  ProgramContentSelection,
  InviteLearners,
  Success,
}

// eslint-disable-next-line no-restricted-syntax
export enum GoogleProgramCreationSteps {
  ProgramTypeSelection,
  ContractSelection,
  ProgramCreation,
  ProgramContentCurationSelection,
  ProgramContentSelection,
  InviteLearners,
  Success,
}
